import {HistoryStorageWithMaterial} from '@domain/material-storage'
import {Recipe} from '@domain/materials'
import {RecipeComponentType} from '@domain/shared'
import {OperationModeSnapshot} from '@hconnect/common/types'

import {getRecipeComponentsWithMaterial} from './materials'

/**
 * function that returns storage ids connected to particular recipeId
 */
const getStorageIdsByRecipeId = (storages: HistoryStorageWithMaterial[], recipe: Recipe) => {
  return storages.filter(
    (storage) =>
      getRecipeComponentsWithMaterial(storage.materialId, recipe, [RecipeComponentType.Output])
        .length > 0
  )
}

/**
 * function which returns storage ids for particular operation mode
 */
export const getStoragesWithMaterialForOperationMode = (
  recipesById: Record<string, Recipe>,
  storages: HistoryStorageWithMaterial[],
  operationMode: OperationModeSnapshot
): HistoryStorageWithMaterial[] => {
  if (!operationMode.recipeId || !recipesById[operationMode.recipeId]) {
    return []
  }

  return getStorageIdsByRecipeId(storages, recipesById[operationMode.recipeId])
}
